import { APIClient } from '@frontend/api-utils';

export class LockerActuatorClient extends APIClient {
    public static readonly endpoint = '/locker-api/v1';

    public static async openLocker(accountId: string, iotId: string, deviceId: string, lockerId: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers/${lockerId}/open`);
        return await this.handleVoidResponse(response);
    }

    public static async queryLocker(accountId: string, iotId: string, deviceId: string, lockerId: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers/${lockerId}/query`);
        return await this.handleVoidResponse(response);
    }
}
